import { render, staticRenderFns } from "./tipoFotos.vue?vue&type=template&id=0d79b351"
import script from "./tipoFotos.vue?vue&type=script&lang=js"
export * from "./tipoFotos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports